import { useSanityProduct } from 'hooks/product/useSanityProduct';
import { useShopifyProduct } from 'hooks/product/useShopifyProduct';
import type { CartLineItem as CartLineItemType } from 'types/cart/CartLineItem';

import { createSubscriptionUpsellOptions } from '../utils/createSubscriptionUpsellOptions';
import { getSelectorSubtitle, getSubtitle } from '../utils/getSubtitle';
import { isOneTimePurchase } from '../utils/typeInference';

export const usePurchaseTypeConfig = (lineItem: CartLineItemType) => {
  const { data: shopifyProduct } = useShopifyProduct(
    lineItem.merchandise.product.handle,
  );

  const sanityProduct = useSanityProduct(lineItem.merchandise.product.handle);

  const { id, cost, merchandise, quantity } = lineItem;
  const { product, image, maxQuantity } = merchandise;

  return {
    id,
    cost,
    merchandise,
    quantity,
    product,
    image,
    maxQuantity,
    handle: product.handle,
    isSubscription: !isOneTimePurchase(lineItem),
    productTitle: lineItem.merchandise.product.title,
    subtitle: getSubtitle(lineItem, shopifyProduct),
    selectorSubtitle: getSelectorSubtitle(lineItem, shopifyProduct),
    isPreorder: sanityProduct?.isPreorder,
    isMoneyBackGuarantee:
      !!sanityProduct?.isMoneyBackGuarantee &&
      merchandise.availableForSale &&
      cost.totalAmount.amount > 0,
    upsellOptions: createSubscriptionUpsellOptions(lineItem, shopifyProduct),
  };
};
